var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Slider, { createSliderWithTooltip } from 'rc-slider';
import * as React from 'react';
import { connect } from 'react-redux';
import { skipScenarioEvents } from './actions';
var SliderWithTip = createSliderWithTooltip(Slider);
function formatMinutes(ms) {
    var seconds = Math.round(ms / 1000);
    var sec = seconds % 60;
    var min = (seconds - sec) / 60;
    return min + ":" + sec.toString().padStart(2, '0');
}
// TODO: Increment the current offset continously as time progresses (with setTimeout), even if there are no events.
var ScenarioProgressBar = /** @class */ (function (_super) {
    __extends(ScenarioProgressBar, _super);
    function ScenarioProgressBar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { offset: null };
        _this.onChange = function (offset) {
            console.log('onChange', offset, _this.props.scenarioStatus.lastOffset, _this.state.offset);
            _this.setState({ offset: offset });
        };
        _this.onAfterChange = function (value) {
            var _a = _this.props, skipScenarioEvents = _a.skipScenarioEvents, scenarioStatus = _a.scenarioStatus;
            skipScenarioEvents(value - scenarioStatus.lastOffset);
            _this.setState({ offset: null });
        };
        _this.renderTip = function (offset) {
            var scenario = _this.props.scenario;
            var lastOffset = scenario.events[scenario.events.length - 1].offset;
            return formatMinutes(offset) + " / " + formatMinutes(lastOffset);
        };
        return _this;
    }
    ScenarioProgressBar.prototype.render = function () {
        var _a = this.props, scenario = _a.scenario, scenarioStatus = _a.scenarioStatus;
        var offset = this.state.offset;
        if (!scenario || !scenarioStatus) {
            return null;
        }
        var lastOffset = scenario.events[scenario.events.length - 1].offset;
        var value = Math.min(offset === null ? scenarioStatus.lastOffset : offset, lastOffset);
        return (React.createElement("div", null,
            React.createElement(SliderWithTip, { min: 0, max: lastOffset, value: value, onChange: this.onChange, onAfterChange: this.onAfterChange, tipFormatter: this.renderTip })));
    };
    return ScenarioProgressBar;
}(React.PureComponent));
export default connect(function (_a) {
    var scenario = _a.scenario, scenarioPlay = _a.scenarioPlay, scenarioStatus = _a.scenarioStatus, scenarioSpeed = _a.scenarioSpeed;
    return ({ scenario: scenario, scenarioPlay: scenarioPlay, scenarioStatus: scenarioStatus, scenarioSpeed: scenarioSpeed });
}, { skipScenarioEvents: skipScenarioEvents })(ScenarioProgressBar);



//////////////////
// WEBPACK FOOTER
// ./src/components/VehicleController/ScenarioProgressBar.tsx
// module id = 1817
// module chunks = 0